import {useTranslation} from 'react-i18next';
import {useFormikContext} from 'formik';
import {Helper} from '@tickchak/react-share/app';
import * as css from './SubscriptionTypeStep.css';
import Input from '../../../../../../component/input/Input';
import {clock} from '../../../../../../assets/symbols/symbols/Symbols.css';
import SubscriptionTypeCard from '../components/SubscriptionTypeCard';
import CategorySelector from '../components/CategorySelector';
import {SubscriptionFormValues} from '../../createSubscriptionForm.types';

const INTEGRATED_PLAN_IMAGE = 'https://static.tickchak.co.il/images/app/subscription/IntegratedPlan.png';
const OPEN_PLAN_IMAGE = 'https://static.tickchak.co.il/images/app/subscription/openPlan.png';

function SubscriptionTypeStep() {
    const {t} = useTranslation('subscriptions');
    const {values, setFieldValue} = useFormikContext<SubscriptionFormValues>();
    
    const subscriptionTypes = [
        {
            id: 'open',
            label: t('openSubscription'),
            icon: OPEN_PLAN_IMAGE,
            isActive: true,
        },
        {
            id: 'combined',
            label: t('combinedSubscription'),
            icon: INTEGRATED_PLAN_IMAGE,
            isActive: false
        },
        {
            id: 'close',
            label: t('closedSubscription'),
            icon: INTEGRATED_PLAN_IMAGE,
            isActive: false
        }
    ];

    const handleTypeSelect = (typeId: string) => {
        const selectedType = subscriptionTypes.find(type => type.id === typeId);
        if(selectedType?.isActive) {
            setFieldValue('subscriptionType', typeId);
        }
    };

    const handleCategorySelect = (catId: number) => {
        const currentCategories = values.category || [];
        if(currentCategories.includes(catId)) {
            setFieldValue('category', currentCategories.filter(id => id !== catId));
        } else {
            setFieldValue('category', [...currentCategories, catId]);
        }
    };

    return (
        <css.container>
            <css.sectionTitle>{t('chooseSubscriptionType')}</css.sectionTitle>
            
            <css.inputWrapper>
                <Input
                    name="subscriptionName"
                    text={t('subscriptionName')}
                    icon={<css.inputIcon $icon={clock} />} 
                    events={undefined} 
                    className={undefined} 
                    forwardRef={undefined}
                />
                <Helper
                    title={t('subscriptionNameHelperTitle')}
                    content={t('subscriptionNameHelperContent')}
                    size='small'
                />
            </css.inputWrapper>
            
            <css.typesGrid>
                {subscriptionTypes.map((type) => (
                    <SubscriptionTypeCard
                        key={type.id}
                        type={type}
                        isSelected={values.subscriptionType === type.id}
                        onSelect={() => handleTypeSelect(type.id)}
                    />
                ))}
            </css.typesGrid>

            <CategorySelector onCategorySelect={handleCategorySelect} />
        </css.container>
    );
}

export default SubscriptionTypeStep;

